export const BG_P1 = 'bg_p1';
export const CA_P4 = 'ca_p4';
export const CAAB = 'caab';
export const CABC = 'cabc';
export const CAMB = 'camb';
export const CANB = 'canb';
export const CANL = 'canl';
export const CANS = 'cans';
export const CAON = 'caon';
export const CAPE = 'cape';
export const CAQC = 'caqc';
export const CASK = 'cask';
export const CH = 'ch';
export const CZ = 'cz';
export const DE = 'de';
export const DEMO = 'demo';
export const ES_P1 = 'es_p1';
export const FI = 'fi';
export const FR = 'fr';
export const GAM_TEST = 'gam_test';
export const GR = 'gr';
export const HR_P1 = 'hr_p1';
export const HU = 'hu';
export const ID = 'id';
export const IL = 'il';
export const IT_P1 = 'it_p1';
export const JO = 'jo';
export const JP = 'jp';
export const KZ = 'kz';
export const LB_P1 = 'lb_p1';
export const LT_P1 = 'lt_p1';
export const MV = 'mv';
export const NC = 'nc';
export const NL = 'nl';
export const NZ = 'nz';
export const PL_P1 = 'pl_p1';
export const PMI = 'pmi';
export const PS = 'ps';
export const PT = 'pt';
export const RO = 'ro';
export const SE = 'se';
export const SK = 'sk';
export const TW = 'tw';
export const UA = 'ua';
export const UAT = 'uat';
export const AE = 'ae';
export const EG = 'eg';
export const GB = 'gb';
export const KG = 'kg';
export const SI = 'si';
export const DK = 'dk';
export const PH = 'ph';
export const GT = 'gt';
export const MY = 'my';
export const AZ = 'az';
export const VU = 'vu';
export const CY = 'cy';
export const RS = 'rs';
export const SA = 'sa';
export const AL = 'al';
export const MK = 'mk';
export const BA = 'ba';
export const ME = 'me';
export const TN = 'tn';
export const LY = 'ly';
export const MA = 'ma';
export const MX = 'mx';
export const PK = 'pk';
